import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    count: 0,
    checkAll: [],
    questionTabDetails: [],
    selectedQuestionsBySelectAll: [],
    resetQuestionsBySelectAll: 0,
    selectAll: {}
}

const importSlice = createSlice(
    {
        name: 'import',
        initialState,
        reducers: {

            setCountToImport: (state, action) => {
                console.log('action', action);
                state.count = action.payload.item + 1;
            },
            selectAllCheckbox: (state, action) => {
                state.checkAll = action.payload.item
            },
            setQuestionTabDetails: (state, action) => {
                state.questionTabDetails = action.payload.item
            },
            setSelectedQuestionsBySelectAll: (state, action) => {
                state.selectedQuestionsBySelectAll = action.payload.item
            },
            setResetQuestionsBySelectAll: (state, action) => {
                state.resetQuestionsBySelectAll = action.payload.item
            },
            setSelectAll: (state, action) => {
                state.selectAll = action.payload.item
            }
        }
    });

export const { setCountToImport, selectAllCheckbox, setQuestionTabDetails, setSelectedQuestionsBySelectAll, setResetQuestionsBySelectAll, setSelectAll } = importSlice.actions;

// const { actions, reducer } = importSlice;
// export const { deleteTodo } = importSlice.actions;

export const importCount = (state: any) => state;

export default importSlice.reducer;
 